import styled from 'styled-components';

export const ProductCustomizationPanel = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ProductCustomizationFixedHeader = styled.div`
  box-shadow: ${p => p.theme.token('drop-shadow-top-nav')};
  z-index: ${Styles.zIndex.below};
`;

export const ProductCustomizationScrollableArea = styled.div`
  flex: 1 1 auto;
  ${Styles.desktop`
    overflow: auto;
  `}
`;
